import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return o(), t("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      d: "M19 4H5l5.185 6.194v6.193L14.333 20v-9.806z"
    }, null, -1)
  ])]);
}
const c = { render: l };
export {
  c as default,
  l as render
};
